import {AfterViewInit, Component} from '@angular/core';
import {AppService} from '../../services/app.service';

@Component({
  selector: 'pm-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements AfterViewInit {

  constructor(
    private app: AppService
  ) {
    app.setTitle('Product Detail');
  }

  ngAfterViewInit(): void {
    $(document).ready(() => {
      $('select').niceSelect();
    });

    // datepicker
    $('#datepicker').datepicker({
      uiLibrary: 'bootstrap4'
    });

    $('.top_selling_slider').owlCarousel({
      loop: true,
      margin: 15,
      nav: true,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        600: {
          items: 1,
          nav: true
        },
        768: {
          items: 2,
          nav: true
        },
        992: {
          items: 3,
          loop: false,
          margin: 10,
          nav: true
        },
        1200: {
          items: 3,
          // nav:true,
          loop: false,
          margin: 30
        }
      }
    });

    $('.slider-single').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      dots: true,
      adaptiveHeight: true,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    });

    $('.slider-nav')
      .on('init', (event, slick) => {
        $('.slider-nav .slick-slide.slick-current').addClass('is-active');
      })
      .slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        vertical: true,
        focusOnSelect: false,
        infinite: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        }, {
          breakpoint: 640,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        }, {
          breakpoint: 420,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        }]
      });

    $('.slider-single').on('afterChange', (event, slick, currentSlide) => {
      $('.slider-nav').slick('slickGoTo', currentSlide);
      const currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
      $('.slider-nav .slick-slide.is-active').removeClass('is-active');
      $(currrentNavSlideElem).addClass('is-active');
    });

    $('.slider-nav').on('click', '.slick-slide', (event) => {
      event.preventDefault();
      const goToSingleSlide = $(event.target).data('slick-index');

      $('.slider-single').slick('slickGoTo', goToSingleSlide);
    });
  }

}
